module.exports = __webpack_public_path__ + "./Anita_color_cce7b00bb8fb5c7d7cffff64526cdf72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Anita_color.jpg
// module id = 584
// module chunks = 0